<template>
  <div class="d-flex">
    <div class="me-auto">
      <span class="font-weight-regular">{{$t("meetings")}}</span>
    </div>
    <div v-for="item in sortingList" :key="item.type">
      <a-btn v-if="item.type !== 'meetingName'" color="#FFFFFF" class="ml-2" outlined x-small @click.stop="onSOrtButtonClick(item)">{{ item.label }} <v-icon size="18">{{
        item.direction === "Ascending" ? "mdi-arrow-up" : "mdi-arrow-down"
      }}</v-icon></a-btn>
    </div>
  </div>
</template>

<script>
import ABtn from "../../wrapper-component/ABtn.vue";
import _ from "lodash";
export default {
  name: "AgendaFrozenHeaderTemplate",
  components: {
    ABtn
  },
  props: {
    sortOptions: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      isAscending: true,
      list: [
        {
          type: "meetingName",
          label: this.$t("agenda.lblMeetingType"),
          direction: null,
        },
        {
          type: "scheduledEndTimeInUTC",
          label: this.$t("poll.lblDate"),
          direction: null,
        },
      ],
    };
  },
  computed: {
   sortingList() {
      return this.list;
    },
  },
  mounted() {
    if (!_.isEmpty(this.sortOptions)) {
      this.sortOptions.columns.forEach((element) => {
        const data = this.list.find((l) => l.type === element.field);
        if (data) {
          data.direction = element.direction;
          const index = this.list.findIndex((l) => l.type === element.field);
          this.$set(this.list, index, data);
        }
      });
    }
  },
  methods:{
     onSOrtButtonClick(item) {
      if (!item.direction) {
        item.direction = "Ascending";
      } else if (item.direction === "Ascending") {
        item.direction = "Descending";
      } else if (item.direction === "Descending") {
        //item.direction = null;
        item = {
          type: "scheduledEndTimeInUTC",
          label: this.$t("poll.lblDate"),
          direction: "Ascending",
        };
      }
      const index = this.list.findIndex((l) => l.type === item.type);
      this.$set(this.list, index, item);

      const params = {
        column: item.type,
        direction: item.direction,
      };
      //if (!params.direction) {
      this.list.forEach((element, index) => {
        if (element.type !== item.type) {
          element.direction = null;
          this.$set(this.list, index, element);
        }
      });
      //}
      this.$root.$emit("agendaGridSorting", params);
    },
  }
};
</script>

